module.exports = __webpack_public_path__ + "static/media/05-06.863f9c93.png";